<template>
  <div class="about-page">
    <div class="container">
      <!-- 基本信息卡片 -->
      <div class="info-card">
        <div class="card-header">
          <h2><i class="fas fa-info-circle"></i> {{ $t('about.basicInfo') }}</h2>
        </div>
        <div class="card-content">
          <div class="info-item">
            <span class="label">{{ $t('about.userManual') }}：</span>
            <a href="https://docs.qq.com/doc/DQW14Z1NSb0FSTEhw" target="_blank" class="external-link">{{ $t('about.clickToView') }}</a>
          </div>
          <div class="info-item">
            <span class="label">{{ $t('about.appManual') }}：</span>
            <a href="https://docs.qq.com/doc/DQVlKRHBXamh3bnV2" target="_blank" class="external-link">{{ $t('about.clickToView') }}</a>
          </div>
          <div class="info-item">
            <span class="label">{{ $t('about.csdnBlog') }}：</span>
            <a href="https://blog.csdn.net/qq_40905836?type=blog" target="_blank" class="external-link">{{ $t('about.clickToView') }}</a>
          </div>
          <div class="info-item">
            <span class="label">{{ $t('about.bilibiliVideo') }}：</span>
            <a href="https://space.bilibili.com/631384833/video" target="_blank" class="external-link">{{ $t('about.clickToView') }}</a>
          </div>
          <div class="info-item">
            <span class="label">{{ $t('about.versionAddress') }}：</span>
            <a href="http://www.tfcenter.com.cn" target="_blank" class="external-link">{{ $t('about.officialDownload') }}</a>
            <a href="https://share.weiyun.com/tFAN6x5p" target="_blank" class="external-link">{{ $t('about.weiyunDownload') }}</a>
          </div>
          <div class="info-item">
            <span class="label">{{ $t('about.otherAccess') }}：</span>
            <a href="javascript:void(0)" @click="showAccessModal" class="external-link">{{ $t('about.clickToView') }}</a>
          </div>
          <div class="info-item">
            <span class="label">{{ $t('about.contactEmail') }}：</span>
            <span class="value">tfcenter@126.com</span>
          </div>
          <div class="info-item">
            <span class="label">{{ $t('about.qqGroup') }}：</span>
            <span class="value">599362559</span>
            <a target="_blank" href="https://qm.qq.com/q/aSTuXp9rig">
              <img border="0" src="//pub.idqqimg.com/wpa/images/group.png" :alt="$t('about.qqGroup')" :title="$t('about.qqGroup')">
            </a>
          </div>
          <div class="info-item">
            <span class="label">{{ $t('about.officialWebsite2') }}：</span>
            <a href="http://www.tfcenter.com.cn" target="_blank" class="external-link">{{ $t('about.clickToView') }}</a>
          </div>
        </div>
      </div>

      <!-- 功能信息卡片 -->
      <div class="info-card">
        <div class="card-header">
          <h2><i class="fas fa-cogs"></i> {{ $t('about.featureInfo') }}</h2>
        </div>
        <div class="card-content">
          <ol class="feature-list">
            <li>{{ $t('about.feature1') }}</li>
            <li>{{ $t('about.feature2') }}</li>
            <li>{{ $t('about.feature3') }}</li>
            <li>{{ $t('about.feature4') }}</li>
            <li>{{ $t('about.feature5') }}</li>
            <li>{{ $t('about.feature6') }}</li>
            <li>{{ $t('about.feature7') }}</li>
            <li>{{ $t('about.feature8') }}</li>
            <li>{{ $t('about.feature9') }}</li>
            <li>{{ $t('about.feature10') }}</li>
            <li>{{ $t('about.feature11') }}</li>
            <li>{{ $t('about.feature12') }}</li>
            <li>{{ $t('about.feature13') }}</li>
            <li>{{ $t('about.feature14') }}</li>
            <li>{{ $t('about.passwordReset') }}：
              <ul class="sub-list">
                <li>{{ $t('about.passwordResetLinux') }}</li>
                <li>{{ $t('about.passwordResetWindows') }}</li>
              </ul>
            </li>
          </ol>
        </div>
      </div>

      <!-- 免责声明卡片 -->
      <div class="info-card">
        <div class="card-header">
          <h2><i class="fas fa-exclamation-triangle"></i> {{ $t('about.disclaimer') }}</h2>
        </div>
        <div class="card-content">
          <ol class="disclaimer-list">
            <li>{{ $t('about.disclaimer1') }}</li>
            <li>{{ $t('about.disclaimer2') }}</li>
            <li>{{ $t('about.disclaimer3') }}</li>
          </ol>
        </div>
      </div>

      <!-- 更新日志卡片 -->
      <div class="info-card">
        <div class="card-header">
          <h2><i class="fas fa-history"></i> {{ $t('about.updateLog') }}</h2>
        </div>
        <div class="card-content log-content">
          <div class="log-entry" v-for="(log, index) in updateLogs" :key="index">
            <h3 class="log-version">{{ log.version }}</h3>
            <ul class="log-items">
              <li v-for="(item, i) in log.items" :key="i" v-html="item"></li>
            </ul>
          </div>
        </div>
      </div>

      <!-- 访问方式弹窗 -->
      <el-dialog v-model="accessModalVisible" :title="$t('about.otherAccess')" :width="isMobile ? '100%' : '600px'">
        <div class="access-info">
          <div class="access-item">
            <span class="access-label">{{ $t('about.osLabel') }}：</span>
            <el-tag size="small">{{ systemInfo.osType || $t('about.unknown') }}</el-tag>
            <el-tag size="small">{{ systemInfo.platform || $t('about.unknown') }}</el-tag>
          </div>
          <div class="access-item">
            <span class="access-label">{{ $t('about.ipv6HttpAddress') }}：</span>
            <div class="access-url">
              <el-tag v-if="systemInfo.webSwitch" type="success" size="small">{{ $t('about.enabled') }}</el-tag>
              <el-tag v-else type="danger" size="small">{{ $t('about.notEnabled') }}</el-tag>
              <template v-if="systemInfo.webSwitch">
                <el-input v-model="systemInfo.ipv6HttpUrl" readonly v-if="systemInfo.ipv6HttpUrl">
                  <template #append>
                    <el-tooltip :content="$t('about.visit')" placement="top">
                      <el-button
                        type="primary"
                        @click="openUrl(systemInfo.ipv6HttpUrl)"
                        :icon="Link"
                        size="small"
                        circle
                      />
                    </el-tooltip>
                    <el-tooltip :content="$t('about.copy')" placement="top">
                      <el-button
                        type="primary"
                        @click="copyToClipboard(systemInfo.ipv6HttpUrl)"
                        :icon="CopyDocument"
                        size="small"
                        circle
                      />
                    </el-tooltip>
                  </template>
                </el-input>
                <el-tag v-else type="warning" size="small">{{ $t('about.notDetected') }}</el-tag>
              </template>
              <el-tag v-else type="info" size="small">{{ $t('about.httpServiceNotEnabled') }}</el-tag>
            </div>
          </div>
          <div class="access-item">
            <span class="access-label">{{ $t('about.ipv6HttpsAddress') }}：</span>
            <div class="access-url">
              <el-tag v-if="systemInfo.httpsWebSwitch" type="success" size="small">{{ $t('about.enabled') }}</el-tag>
              <el-tag v-else type="danger" size="small">{{ $t('about.notEnabled') }}</el-tag>
              <template v-if="systemInfo.httpsWebSwitch">
                <el-input v-model="systemInfo.ipv6HttpsUrl" readonly v-if="systemInfo.ipv6HttpsUrl">
                  <template #append>
                    <el-tooltip :content="$t('about.visit')" placement="top">
                      <el-button
                        type="primary"
                        @click="openUrl(systemInfo.ipv6HttpsUrl)"
                        :icon="Link"
                        size="small"
                        circle
                    />
                    </el-tooltip>
                    <el-tooltip :content="$t('about.copy')" placement="top">
                      <el-button
                        type="primary"
                        @click="copyToClipboard(systemInfo.ipv6HttpsUrl)"
                        :icon="CopyDocument"
                        size="small"
                        circle
                      />
                    </el-tooltip>
                  </template>
                </el-input>
                <el-tag v-else type="warning" size="small">{{ $t('about.notDetected') }}</el-tag>
              </template>
              <el-tag v-else type="info" size="small">{{ $t('about.httpsServiceNotEnabled') }}</el-tag>
            </div>
          </div>
        </div>
        <template #footer>
          <el-button @click="accessModalVisible = false">{{ $t('about.close') }}</el-button>
        </template>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { ElMessage } from 'element-plus';
import { Link, CopyDocument } from '@element-plus/icons-vue';
import { API_BASE_URL } from '@/config';

export default {
  name: 'AboutPage',
  setup() {
    const { t } = useI18n()
    const accessModalVisible = ref(false);
    const systemInfo = ref({
      osType: '',
      platform: '',
      ipv6HttpUrl: '',
      ipv6HttpsUrl: '',
      httpsWebSwitch: false,
      webSwitch: false
    });

    const isMobile = window.innerWidth < 768;

    // 更新日志数据
    const updateLogs = ref([
      {
        version: 'v4.2.0',
        items: [
          `(1) ${t('about.log420item1')}`,
          `(2) ${t('about.log420item2')}`,
          `(3) ${t('about.log420item3')}`,
          `(4) ${t('about.log420item4')}`,
          `(5) ${t('about.log420item5')}`,
          `(6) ${t('about.log420item6')}`
        ]
      },
      {
        version: 'v4.1.1',
        items: [
          `(1) ${t('about.log411item1')}`,
          `(2) ${t('about.log411item2')}`,
          `(3) ${t('about.log411item3')}`,
          `(4) ${t('about.log411item4')}`,
          `(5) ${t('about.log411item5')}`,
          `(6) ${t('about.log411item6')}`,
          `(7) ${t('about.log411item7')}`
        ]
      },
      {
        version: 'v4.1.0',
        items: [
          `(1) ${t('about.log410item1')}`,
          `(2) ${t('about.log410item2')}`
        ]
      },
      {
        version: 'v4.0.3',
        items: [
          `(1) ${t('about.log403item1')}`,
          `(2) ${t('about.log403item2')}`,
          `(3) ${t('about.log403item3')}`
        ]
      },
      {
        version: 'v4.0.2',
        items: [
          `(1) ${t('about.log402item1')}`,
          `(2) ${t('about.log402item2')}`,
          `(3) ${t('about.log402item3')}`,
          `(4) ${t('about.log402item4')}`
        ]
      },
      {
        version: 'v4.0.1',
        items: [
          `(1) ${t('about.log401item1')}`,
          `(2) ${t('about.log401item2')}`
        ]
      },
      {
        version: 'v4.0.0',
        items: [
          `(1) ${t('about.log400item1')}`,
          `(2) ${t('about.log400item2')}`,
          `(3) ${t('about.log400item3')}`,
          `(4) ${t('about.log400item4')}`,
          `(5) ${t('about.log400item5')}`,
          `(6) ${t('about.log400item6')}`,
          `(7) ${t('about.log400item7')}`,
          `(8) ${t('about.log400item8')}`
        ]
      },
      {
        version: 'v3.4.2',
        items: [
          `(1) ${t('about.log342item1')}`,
          `(2) ${t('about.log342item2')}`
        ]
      },
      {
        version: 'v3.4.1',
        items: [
          `(1) ${t('about.log341item1')}`,
          `(2) ${t('about.log341item2')}`,
          `(3) ${t('about.log341item3')}`,
          `(4) ${t('about.log341item4')}`
        ]
      },
    ]);

    // 获取系统信息
    const fetchSystemInfo = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/get-loginSysInfo`, {
          credentials: 'include'
        });
        const data = await response.json();
        if (data.errCode === 0) {
          systemInfo.value = data;
        } else {
          ElMessage.warning(data.errMsg || t('about.fetchSystemInfoFailed'));
        }
      } catch (error) {
        console.error(t('about.fetchSystemInfoFailed'), error);
        ElMessage.error(t('about.networkError'));
      }
    };

    // 显示访问方式弹窗
    const showAccessModal = () => {
      accessModalVisible.value = true;
      if (!systemInfo.value.osType) {
        fetchSystemInfo();
      }
    };

    // 复制到剪贴板
    const copyToClipboard = (text) => {
      if (!text) {
        ElMessage.warning(t('about.noContentToCopy'));
        return;
      }

      console.log("---------text:", text);

      const copy = (text) => {
        return new Promise((resolve) => {
          const textarea = document.createElement('textarea');
          textarea.value = text;
          textarea.style.position = 'fixed';
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand('copy');
          document.body.removeChild(textarea);
          resolve();
        });
      };

      copy(text);

      ElMessage.success(t('about.copySuccess'));
    };

    // 修改打开URL方法，增加空值检查
    const openUrl = (url) => {
      if (!url) {
        ElMessage.warning(t('about.invalidUrl'));
        return;
      }

      window.open(url, '_blank');
    };

    onMounted(() => {
    });

    return {
      isMobile,
      updateLogs,
      accessModalVisible,
      systemInfo,
      showAccessModal,
      copyToClipboard,
      openUrl,
      Link,
      CopyDocument
    };
  }
};
</script>

<style scoped>
.about-page {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.container {
  margin: 0 auto;
}

.info-card {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 24px;
  overflow: hidden;
}

.card-header {
  background-color: #f0f2f5;
  padding: 16px 24px;
  border-bottom: 1px solid #e6e6e6;
}

.card-header h2 {
  margin: 0;
  font-size: 18px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 10px;
}

.card-header i {
  font-size: 20px;
}

.card-content {
  padding: 20px 24px;
}

.info-item {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
}

.label {
  font-weight: 500;
  color: #666;
  min-width: 80px;
}

.value {
  color: #333;
}

.external-link {
  color: #409eff;
  text-decoration: none;
  margin-right: 15px;
}

.external-link:hover {
  text-decoration: underline;
}

.feature-list, .disclaimer-list {
  padding-left: 20px;
  margin: 0;
}

.feature-list li, .disclaimer-list li {
  margin-bottom: 8px;
  line-height: 1.6;
  color: #333;
}

.sub-list {
  padding-left: 20px;
  margin-top: 5px;
}

.sub-list li {
  margin-bottom: 5px;
}

.log-content {
  max-height: 600px;
  overflow-y: auto;
}

.log-entry {
  margin-bottom: 20px;
}

.log-version {
  font-size: 16px;
  color: #409eff;
  margin: 0 0 10px 0;
  padding-bottom: 5px;
  border-bottom: 1px dashed #e6e6e6;
}

.log-items {
  padding-left: 20px;
  margin: 0;
}

.log-items li {
  margin-bottom: 8px;
  line-height: 1.6;
  color: #666;
}

/* 访问信息弹窗样式 */
.access-info {
  padding: 10px;
}

.access-item {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.access-label {
  font-weight: bold;
  width: 125px;
  flex-shrink: 0;
}

.access-value {
  margin-right: 10px;
}

.access-url {
  flex-grow: 1;
  display: flex;
  align-items: center;
  gap: 10px;
}

.el-input {
  flex-grow: 1;
}

.access-url .el-tag {
  margin-left: 10px;
}

@media (max-width: 768px) {
  .card-content {
    padding: 15px;
  }

  .info-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 3px;
  }

  .label {
    margin-bottom: 2px;
  }

  .access-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .access-url {
    width: 100%;
    margin-top: 8px;
  }
}
</style>
